import { forwardRef, useImperativeHandle, useState } from "react";
import { StepperFormProps, StepperFormRef } from "../types/StepperFormProps";
import { Box } from "../utils/muiImports";

const StepperForm = forwardRef<StepperFormRef, StepperFormProps>(
  (
    {
      initialData,
      onSubmit,
      renderStepContent,
      steps,
      onStepChange,
      errors,
      children,
    },
    ref
  ) => {
    const [activeStep, setActiveStep] = useState<number>(0);
    const [formData] = useState<Record<string, any>>(initialData);

    const handleNext = () => {
      onStepChange?.(true, activeStep);
    };

    const handleBack = () => {
      console.log("Back" + activeStep);
      setActiveStep((prev) => {
        onStepChange?.(false, prev - 1);
        return prev;
      });
    };

    const handleFinish = () => {
      onSubmit(formData);
      setActiveStep(0);
    };

    const handleSkip = () => {
      if (activeStep < steps.length - 1) {
        setActiveStep((prev) => {
          const newStep = prev + 1;
          onStepChange?.(false, newStep);
          return newStep;
        });
      }
    };

    useImperativeHandle(ref, () => ({
      next: () =>
        activeStep === steps.length - 1 ? handleFinish() : handleNext(),
      back: handleBack,
      skip: handleSkip,
      save: handleFinish,
      activeStep,
      isLastStep: activeStep === steps.length - 1,
    }));
    return <Box sx={{ width: "100%", mt: 2, ml: 2 }}>{children}</Box>;
  }
);
export default StepperForm;
